import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-01-22'
        tag='Poshmark'
        title='Poshmark Tip: Where To Source and How To Sell Designers'
      >
        <p>
          When you visit online marketplaces, you will notice one type of item that sells well: designers. No matter the
          category, branded products almost always draw the attention of shoppers. Potential buyers purchase the name of
          the item, along with the company’s values, characteristics, and the quality they integrate into their
          products.
        </p>
        <p>
          So, when selling on a platform like Poshmark, it is always better to include the label of your item. But where
          do you source luxury items? What if you are also on a budget but still want to list designer items? Here is
          OneShop's short guide on selling luxury goods on Poshmark.
        </p>

        <h3>Where to source?</h3>
        <h3>Outlet Malls</h3>
        <p>
          Your best go-to destinations are outlet stores in the malls. Now, you may be thinking about the difference
          between outlets and retail ones. But first, there is no need to worry about authenticity as outlets also sell
          the original branded items. However, there are a few differences.
        </p>
        <p>
          First, brands and designer labels produce separate collections for their retail and outlet stores. This means
          that sometimes, depending on the company, only 10% to 20% of the items sold in retail are found in outlet
          stores. This is why you may be looking for a specific luxury handbag in a Gucci outlet but is unable to see it
          there. However, you can definitely find it or at least, request it in the retail store.
        </p>
        <p>
          Secondly, given that this is a separate collection, outlet stores carry lower quality items, also viewed as a
          secondhand style. When you are looking for a specific pair of shoes, for instance, the pair found in outlet
          stores have a different color, material quality, and limited variety of shoe sizes. This is the main downside
          to sourcing from outlets.
        </p>
        <p>
          However, you can still find original items seen from runway shows. The catch is, it is only in one size.
          Although luck definitely plays a hand in grabbing these pieces, you can also sign up for promotions, email
          subscriptions, and coupons from your preferred outlet store. You can get additional discounts or be part of
          the first few who visit during a sale.
        </p>
        <p>
          Lastly, merchandise in outlet stores definitely comes at a lesser retail price. Some reduce the price to 25%
          to 65% less than full retail. But of course, this still varies from one brand to another.
        </p>

        <h3>Family and Friends</h3>
        <p>
          Where else to easily source luxury goods except people close to you? You can ask your trusted friend to
          ransack their closet and sell their unwanted items. Who knows, you may be able to get your hands on their
          Michael Kors purse they only used a few times.
        </p>
        <p>
          While you are at it, you can also help them sell their other clothes and accessories they no longer want. In
          this way, you can get more earnings and they will also have more space for a change of wardrobe. It is a
          win-win situation.
        </p>

        <h3>Lucky Finds in Thrift Stores</h3>
        <p>
          If you are on a tight budget, your best option is to visit thrift stores and boutiques. The advantage here is
          there is an extensive variety of items you can purchase. From secondhand clothes, vintage jeans, kids apparel,
          shoes, to even some home decor pieces.
        </p>
        <p>
          The huge bonus is here is these come at incredibly cheap prices. You can even haggle or negotiate the fees,
          especially if you are buying in bulk. The more items you purchase, the more you have the chance to get them at
          a low price.
        </p>
        <p>
          Take note, however, to check for authenticity when sourcing from thrift stores. Be wary of fakes, as these are
          usually similar to the original branded ones. Your best bet is to research the authentic design of a product
          so you can easily spot if the item you have your eyes on, is the real deal.
        </p>

        <h3>How to sell?</h3>
        <p>
          If you scroll through a social media platform like Instagram and listings of top-performing Poshmark sellers,
          you will notice that posts with the most likes are professional-looking photos. These clear images, especially
          of outfits, draw attention to their attractiveness. This is why even your item is a designer but you don't
          know how to market them properly, you may be unable to sell them.
        </p>
        <p>
          What you need to do first is to take clear photos. Make sure you have good lighting (natural sunlight works
          best), you take different angles of the product, and you never use filters. Doing the latter can affect the
          color of the item when viewed on the screen. Buyers may give you complaints once they receive the product,
          saying it looked entirely different from what you posted.
        </p>
        <p>
          In taking photos, you have to prove the authenticity of the designer goods. People would trust you more if you
          show clear evidence that your items are branded. To do this, take photos of the tags, a closeup of the
          material (this includes the stitching and inside lining), and all views (top, bottom, sides).
        </p>
        <p>
          Potential buyers are always cautious of fakes so they are keen on details. When you provide these identifiers,
          you will most likely close a seal.
        </p>
        <p>
          Be patient, however, as some will still message you for additional photos. Be understanding as they only want
          to ensure they are buying the authentic kind and that you have these items on you--and not simply grabbing
          photos from the internet.
        </p>
        <p>
          Lastly, continue sharing your listings. The more your items appear on the front or latest pages on Poshmark,
          the more people will see it and hopefully, inquire about it. To refresh your listing, you can change a little
          bit in the description or modify the photos. When you add more details, more potential buyers will trust you
          for being meticulous about what you sell.
        </p>

        <h3>Let OneShop Sell For You</h3>
        <p>
          As a seller, you may find it confusing or maybe even tough to manage your listings, especially when you only
          do this as part-time work or side hustle. This is where a platform like OneShop comes in handy.
        </p>
        <p>
          OneShop is a mobile app that helps sellers like you navigate marketplaces such as Poshmark, Mercari, and
          Tradesy. The simplicity of the process has made it a trusted app among thousands of customers across the
          globe.
        </p>
        <p>
          What you only need to do is draft your listings in OneShop. This includes taking photos of your items,
          creating short descriptions for them, and assigning a selling price. Once these are complete, you can easily
          cross-list them over to other online marketplaces.
        </p>
        <p>
          You need not worry about accidentally selling the same listing to others as OneShop automatically handles this
          for you. Once you close a sale for a specific product, OneShop removes that from the rest of the marketplaces
          it was posted on.
        </p>
        <p>
          The bonus? You can also use the app to monitor your profits and losses. It has analytics tailored especially
          for you, so you can have an overview of your sales. In this way, you can find ways to earn more and set goals.
          Of course, OneShop also has a blog where it helps people with tips and tricks to online selling, as every
          marketplace is still different.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
